import { Card } from '@braze/web-sdk';

export const movePinnedCardsToTop = (cards: Card[]) =>
  cards.sort((a, b) => {
    if (a.pinned !== b.pinned) {
      return a.pinned ? -1 : 1;
    }
    return 0;
  });
